// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mdb-wysiwyg-textarea[data-v-d4eabf20] {\n  display: block;\n  padding: 15px;\n  width: 100%;\n  min-height: 100px;\n  max-height: 400px;\n  overflow-y: auto;\n  border: 0;\n  outline: none;\n  resize: none;\n  background: #fff;\n}\n.mdb-wysiwyg-textarea.show-raw[data-v-d4eabf20] {\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
